((Drupal, drupalSettings, algoliasearch, instantsearch, Select) => {
  Drupal.theme.search_index_results = (index, context) => {
    // TODO Handle recipe category page title.
    return `
      <div id="${index}" class="index_results ${
      index.indexOf('parent') !== -1 ? 'parent-class' : ''
    }" role="tabpanel">
      <div class="promo_block"></div>
        <div class="results_main grid grid--4-col">
          <div class="filters" role="dialog">
              <div class="mobile-filters__hide--container">
                <button class="mobile-filters__hide" aria-label="Close filters panel">
                  <span class="mobile-filters__hide-text">close</span>
                </button>
              </div>
              <span class="mobile-filters--container"></span>
              <div class="mobile-filter-button--container">
                <button class="mobile-search-apply-button" role="button" type="button" aria-label="Apply">
                  <span class="mobile-search-apply-button-text--container">
                    <span class="mobile-search-apply-button-text">Apply</span>
                  </span>
                </button>
              </div>
          </div>
          <div class="results_container grid--3-col">
            <div class="results_stats">
              <div class="filter--container">
                <div class="current_results"></div>
                <div class="sort_results"></div>
              </div>
              <div class="active_filters" data-index="${index}" role="region" aria-label="Select Filters to Delete"></div>
              <div class="results_per_page"></div>
            </div>
            <div class="hits grid grid--3-col"></div>
          </div>
        </div>
        <div class="results_bottom">
          <div class="pagination"></div>
        </div>
        <div class="mobile-filter-button--container">
          <button class="mobile-search-filters-button" role="button" type="button" aria-label="Filters" aria-haspopup="dialog">
            <span class="mobile-search-filter-button-text--container">
              <span class="mobile-search-filter-button-text">Filters</span>
            </span>
          </button>
         </div>
      </div>
    `;
  };

  Drupal.theme.search_all_results = (indices, context) => {
    // TODO Handle recipe category page title.

    return `
      <div id="all_indices" class="index_results all_indices" role="tabpanel">
        <div class="results_top">
          <div class="current_results"></div>
          <div class="results_info"></div>
        </div>
        <div class="results_main">
          ${indices
            .map(
              index => `
            <div id="${index.index}_hits">
              <div class="query-info--header"></div>
              <div class="hits grid grid--4-col"></div>
              <div class="hits_header"></div>
            </div>
          `
            )
            .join('')}
        </div>
      </div>
    `;
  };

  Drupal.theme.kabSearchClasses = {
    active: 'active',
    activeTab: 'active-tab',
  };

  Drupal.theme.search_index_tab_select_list = (
    element,
    options,
    values,
    refine,
    currentRefinement
  ) => {
    /** Helper constants and functions for select list. */
    const Keys = {
      Backspace: 'Backspace',
      Clear: 'Clear',
      Down: 'ArrowDown',
      End: 'End',
      Enter: 'Enter',
      Escape: 'Escape',
      Home: 'Home',
      Left: 'ArrowLeft',
      PageDown: 'PageDown',
      PageUp: 'PageUp',
      Right: 'ArrowRight',
      Space: ' ',
      Tab: 'Tab',
      Up: 'ArrowUp',
    };

    const MenuActions = {
      Close: 0,
      CloseSelect: 1,
      First: 2,
      Last: 3,
      Next: 4,
      Open: 5,
      Previous: 6,
      Select: 7,
      Space: 8,
      Type: 9,
    };

    const getActionFromKey = (event, menuOpen) => {
      const { key, altKey, ctrlKey, metaKey } = event;
      // Handle opening of select list when closed.
      if (!menuOpen && (key === Keys.Down || key === Keys.Enter || key === Keys.Space)) {
        return MenuActions.Open;
      }

      // Handle key operations when select list is open.
      if (key === Keys.Down) {
        return MenuActions.Next;
      } else if (key === Keys.Up) {
        return MenuActions.Previous;
      } else if (key === Keys.Home) {
        return MenuActions.First;
      } else if (key === Keys.End) {
        return MenuActions.Last;
      } else if (key === Keys.Escape) {
        return MenuActions.Close;
      } else if (key === Keys.Enter) {
        return MenuActions.CloseSelect;
      } else if (key === Keys.Space) {
        return MenuActions.Space;
      } else if (
        key === Keys.Backspace ||
        key === Keys.Clear ||
        (key.length === 1 && !altKey && !ctrlKey && !metaKey)
      ) {
        return MenuActions.Type;
      }
    };

    // Get updated option index.
    const getUpdatedIndex = (current, max, action) => {
      switch (action) {
        case MenuActions.First:
          return 0;
        case MenuActions.Last:
          return max;
        case MenuActions.Previous:
          return Math.max(0, current - 1);
        case MenuActions.Next:
          return Math.min(max, current + 1);
        default:
          return current;
      }
    };

    // Check if an element is currently scrollable.
    const isScrollable = element => {
      return element && element.clientHeight < element.scrollHeight;
    };

    // Ensure given child element is within the parent's visible scroll area.
    const maintainScrollVisibility = (activeElement, scrollParent) => {
      const { offsetHeight, offsetTop } = activeElement;
      const { offsetHeight: parentOffsetHeight, scrollTop } = scrollParent;
      const isAbove = offsetTop < scrollTop;
      const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
      if (isAbove) {
        scrollParent.scrollTo(0, offsetTop);
      } else if (isBelow) {
        scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
      }
    };

    const Select = function (el, options, values, refine, currentRefinement) {
      // Elements for select list.
      this.el = el;
      this.comboEl = el.querySelector('[role=combobox]');
      this.valueEl = this.comboEl.querySelector('span');
      this.listboxEl = el.querySelector('[role=listbox]');

      // Data for select list.
      this.idBase = this.comboEl.id;
      this.options = options;
      this.values = values ? values : [];
      this.refine = refine ? refine : null;
      this.currentRefinement = currentRefinement ? currentRefinement : '';

      // State for select list.
      this.activeIndex = 0;
      this.open = false;
      this.searchString = '';
      this.searchTimeout = null;
    };

    Select.prototype.init = function () {
      this.valueEl.innerHTML = options[0];
      this.comboEl.addEventListener('blur', this.onComboBlur.bind(this));
      this.comboEl.addEventListener('click', e => {
        if (e.target.parentNode.classList.contains('open')) {
          this.updateMenuState(false);
        } else {
          this.updateMenuState(true);
        }
      });
      this.comboEl.addEventListener('keydown', this.onComboKeyDown.bind(this));
      this.options.map((option, index) => {
        const optionEl = document.createElement('div');
        const optionSpan = document.createElement('span');
        optionEl.setAttribute('role', 'option');
        optionEl.setAttribute('data-value', this.values[index]);
        optionEl.id = `${this.idBase}-${index}`;
        optionEl.className = index === 0 ? 'combo-option option-current' : 'combo-option';
        optionEl.setAttribute('aria-selected', `${index === 0}`);
        optionSpan.innerText = option;
        optionEl.appendChild(optionSpan);
        optionEl.addEventListener('click', event => {
          event.stopPropagation();
          this.onOptionClick(index);
        });
        optionEl.addEventListener('keydown', event => {
          if (event.code === 'Enter') {
            this.onOptionClick(index);
          }
        });
        optionEl.addEventListener('mousedown', this.onOptionMouseDown.bind(this));
        this.listboxEl.appendChild(optionEl);
      });

      // If currentRefinement exists set the sort by element to thate value.
      if (this.currentRefinement !== '') {
        const options = this.el.querySelectorAll('[role=option]');
        [...options].forEach((optionEl, index) => {
          if (optionEl.getAttribute('data-value') === this.currentRefinement) {
            this.onOptionChange(index);
            this.selectOption(index);
            this.updateMenuState(false);
          }
        });
      }
    };

    Select.prototype.getSearchString = function (char) {
      if (typeof this.searchTimeout === 'number') {
        window.clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = window.setTimeout(() => {
        this.searchString = '';
      }, 1000);

      this.searchString += char;
      return this.searchString;
    };

    Select.prototype.onComboKeyDown = function (event) {
      const { key } = event;
      const max = this.options.length - 1;

      const action = getActionFromKey(event, this.open);

      switch (action) {
        case MenuActions.Next:
        case MenuActions.Last:
        case MenuActions.First:
        case MenuActions.Previous:
          event.preventDefault();
          return this.onOptionChange(getUpdatedIndex(this.activeIndex, max, action));
        case MenuActions.CloseSelect:
        case MenuActions.Space:
          event.preventDefault();
          this.selectOption(this.activeIndex);
        case MenuActions.Close:
          event.preventDefault();
          return this.updateMenuState(false);
        case MenuActions.Type:
          this.updateMenuState(true);
          var searchString = this.getSearchString(key);
          return this.onOptionChange(Math.max(0, getIndexByLetter(this.options, searchString)));
        case MenuActions.Open:
          event.preventDefault();
          return this.updateMenuState(true);
      }
    };

    Select.prototype.onComboBlur = function () {
      if (this.ignoreBlur) {
        this.ignoreBlur = false;
        return;
      }
      if (this.open) {
        this.selectOption(this.activeIndex);
        this.updateMenuState(false, false);
      }
    };

    Select.prototype.onOptionChange = function (index) {
      this.activeIndex = index;
      this.comboEl.setAttribute('aria-activedescendant', `${this.idBase}-${index}`);
      const options = this.el.querySelectorAll('[role=option]');
      [...options].forEach(optionEl => {
        optionEl.classList.remove('option-current');
      });
      options[index].classList.add('option-current');
      if (isScrollable(this.listboxEl)) {
        maintainScrollVisibility(options[index], this.listboxEl);
      }
    };

    Select.prototype.onOptionClick = function (index) {
      this.onOptionChange(index);
      this.selectOption(index);
      this.updateMenuState(false);
    };

    Select.prototype.onOptionMouseDown = function () {
      this.ignoreBlur = true;
    };

    Select.prototype.selectOption = function (index) {
      const selected = this.options[index];
      this.valueEl.innerHTML = selected;
      this.activeIndex = index;
      // Update aria-selected for select options.
      const options = this.el.querySelectorAll('[role=option]');
      [...options].forEach(optionEl => {
        optionEl.setAttribute('aria-selected', 'false');
      });
      options[index].setAttribute('aria-selected', 'true');

      if (this.values.length > 0) {
        this.refine(options[index].getAttribute('data-value'));
      } else {
        // Update desktop tabs and results display.
        const tabs = document.querySelectorAll('#algolia_container #tabs .tabindex');
        tabs.forEach(tab => {
          tab.setAttribute('aria-selected', 'false');
          tab.classList.remove(Drupal.theme.kabSearchClasses.active);
        });

        tabs[index].setAttribute('aria-selected', 'true');
        tabs[index].classList.add(Drupal.theme.kabSearchClasses.active);
        const results = document.querySelectorAll('#algolia_results .index_results');
        results.forEach(result => result.classList.remove(Drupal.theme.kabSearchClasses.activeTab));
        results[index].classList.add(Drupal.theme.kabSearchClasses.activeTab);

        // Update url to display a specific index tab.
        if (history.pushState) {
          history.pushState(null, null, `#${tabs[index].getAttribute('data-index')}`);
        } else {
          window.location.hash = `#${tabs[index].getAttribute('data-index')}`;
        }
      }
    };

    Select.prototype.updateMenuState = function (open, callFocus = true) {
      this.open = open;
      this.comboEl.setAttribute('aria-expanded', `${open}`);
      open ? this.el.classList.add('open') : this.el.classList.remove('open');
      open ? this.el.parentNode.classList.add('open') : this.el.parentNode.classList.remove('open');
      if (element === '.js-select') {
        this.el.style.height = open ? `${this.listboxEl.scrollHeight + 40}px` : null;
      }
      callFocus && this.comboEl.focus();
      const activeID = open ? `${this.idBase}-${this.activeIndex}` : this.valueEl.id;
      this.comboEl.setAttribute('aria-activedescendant', activeID);
    };

    // Initialized select list object.
    const selectEl = document.querySelector(element);
    const selectOptions = options;
    const selectComponent = new Select(selectEl, selectOptions, values, refine, currentRefinement);
    selectComponent.init();

    // Set global select object for use in other locations.
    if (element === '.js-select') {
      Drupal.behaviors.searchResults.mobileSelectTabs = selectComponent;
    }
  };

  Drupal.theme.multiSelect = (multiElement, multiOptions, helper, exclude) => {
    /** Helper constants and functions for multiSelect list. */
    const Keys = {
      Backspace: 'Backspace',
      Clear: 'Clear',
      Down: 'ArrowDown',
      End: 'End',
      Enter: 'Enter',
      Escape: 'Escape',
      Home: 'Home',
      Left: 'ArrowLeft',
      PageDown: 'PageDown',
      PageUp: 'PageUp',
      Right: 'ArrowRight',
      Space: ' ',
      Tab: 'Tab',
      Up: 'ArrowUp',
    };

    const MenuActions = {
      Close: 0,
      CloseSelect: 1,
      First: 2,
      Last: 3,
      Next: 4,
      Open: 5,
      Previous: 6,
      Select: 7,
      Space: 8,
      Type: 9,
    };

    // Filter an array of options against an input string and
    // return an array of options that begins with
    // the filter string, case-independent.
    const filterOptions = (options = [], filter, exclude = []) => {
      return options.filter(option => {
        const matches = option.toLowerCase().indexOf(filter.toLowerCase()) === 0;
        return matches && exclude.indexOf(option) < 0;
      });
    };

    const getActionFromKey = (event, menuOpen) => {
      const { key, altKey, ctrlKey, metaKey } = event;
      // Handle opening of multiSelect list when closed.
      if (!menuOpen && (key === Keys.Down || key === Keys.Enter || key === Keys.Space)) {
        return MenuActions.Open;
      }

      // Handle keys when multiSelect list is open.
      if (key === Keys.Down) {
        return MenuActions.Next;
      } else if (key === Keys.Up) {
        return MenuActions.Previous;
      } else if (key === Keys.Home) {
        return MenuActions.First;
      } else if (key === Keys.End) {
        return MenuActions.Last;
      } else if (key === Keys.Escape) {
        return MenuActions.Close;
      } else if (key === Keys.Enter) {
        return MenuActions.CloseSelect;
      } else if (key === Keys.Space) {
        return MenuActions.Space;
      } else if (
        key === Keys.Backspace ||
        key === Keys.Clear ||
        (key.length === 1 && !altKey && !ctrlKey && !metaKey)
      ) {
        return MenuActions.Type;
      }
    };

    // Get updated option index for multiSelect list.
    const getUpdatedIndex = (current, max, action) => {
      switch (action) {
        case MenuActions.First:
          return 0;
        case MenuActions.Last:
          return max;
        case MenuActions.Previous:
          return Math.max(0, current - 1);
        case MenuActions.Next:
          return Math.min(max, current + 1);
        default:
          return current;
      }
    };

    // Check if an element is currently scrollable.
    const isScrollable = element => {
      return element && element.clientHeight < element.scrollHeight;
    };

    // Ensure a given child element is within the parent's visible scroll area.
    const maintainScrollVisibility = (activeElement, scrollParent) => {
      const { offsetHeight, offsetTop } = activeElement;
      const { offsetHeight: parentOffsetHeight, scrollTop } = scrollParent;
      const isAbove = offsetTop < scrollTop;
      const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
      if (isAbove) {
        scrollParent.scrollTo(0, offsetTop);
      } else if (isBelow) {
        scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
      }
    };
    const Multiselect = function (el, options, helper, exclude) {
      // Elements for Multiselect list.
      this.el = el;
      this.inputEl = el.querySelector('input');
      this.listboxEl = el.querySelector('[role=listbox]');

      this.idBase = this.inputEl.id;
      this.selectedEl = document.getElementById(`${this.idBase}-selected`);

      // Data for Multiselect list.
      this.options = options;
      this.helper = helper;
      this.exclude = exclude;

      // State for Multiselect list.
      this.activeIndex = 0;
      this.open = false;
    };

    Multiselect.prototype.setRefinementsInit = function () {
      const buildAddRemoveButtons = (value, index) => {
        // Build button HTML for exisiting refinements.
        const buttonEl = document.createElement('button');
        const listItem = document.createElement('li');
        buttonEl.className = 'remove-option';
        buttonEl.type = 'button';
        buttonEl.id = `${this.idBase}-remove-${index}`;
        buttonEl.setAttribute('aria-describedby', `${this.idBase}-remove`);
        const listener = function (e) {
          if (this.exclude) {
            this.helper.removeFacetExclusion('ingredients_base', value.trim()).search();
          } else {
            this.helper.removeFacetRefinement('ingredients_base', value.trim()).search();
          }
          this.removeOption(index);
        };
        buttonEl.addEventListener('click', listener.bind(this));
        buttonEl.innerHTML = value + ' ';
        listItem.appendChild(buttonEl);
        this.selectedEl.appendChild(listItem);
      };

      if (this.exclude) {
        this.helper.state.facetsExcludes.ingredients_base.forEach((item, index) =>
          buildAddRemoveButtons(item, index)
        );
      } else {
        this.helper.state.facetsRefinements.ingredients_base.forEach((item, index) =>
          buildAddRemoveButtons(item, index)
        );
      }
    };

    // Initialization functions and event listeners for Multiselect list.
    Multiselect.prototype.init = function () {
      this.inputEl.addEventListener('input', this.onInput.bind(this));
      this.inputEl.addEventListener('blur', this.onInputBlur.bind(this));
      this.inputEl.addEventListener('click', () => this.updateMenuState(true));
      this.inputEl.addEventListener('keydown', this.onInputKeyDown.bind(this));
      this.listboxEl.addEventListener('blur', this.onInputBlur.bind(this));
      this.setRefinementsInit();
    };

    Multiselect.prototype.onInput = function () {
      const curValue = this.inputEl.value;
      const matches = filterOptions(this.options, curValue);

      // Set activeIndex to first matching option
      // (or leave it alone, if the active option
      // is already in the matching set).
      const filterCurrentOption = matches.filter(
        option => option === this.options[this.activeIndex]
      );
      if (matches.length > 0 && !filterCurrentOption.length) {
        this.onOptionChange(this.options.indexOf(matches[0]));
      }

      const menuState = this.options.length > 0;
      if (this.open !== menuState) {
        this.updateMenuState(menuState, false);
      }
    };

    Multiselect.prototype.buildOptions = function (options) {
      const mergeArrays = (arr1, arr2) => {
        let r = [],
          h = {};

        while (arr1.length) {
          let e = arr1.shift();
          if (!h[e]) h[e] = 1 && r.push(e);
        }

        while (arr2.length) {
          let e = arr2.shift();
          if (!h[e]) h[e] = 1 && r.push(e);
        }

        return r;
      };

      // Check for existing refinements and add them to an array.
      // If option is in this array, hide it from the Multiselect list.
      let currentSelections = mergeArrays(
        this.helper.state.facetsExcludes.ingredients_base.map(v => v.toLowerCase()),
        this.helper.state.facetsRefinements.ingredients_base.map(v => v.toLowerCase())
      );

      // Build options as they come in from custom widget.
      options.map((option, index) => {
        const optionEl = document.createElement('div');
        optionEl.setAttribute('role', 'option');
        optionEl.id = `${this.idBase}-${index}`;

        const isSelected =
          currentSelections.filter(currentSelection => currentSelection === option.toLowerCase())
            .length > 0;

        optionEl.className =
          index === 0
            ? `select-option option-current ${isSelected ? `option-selected` : ``}`
            : `select-option ${isSelected ? `option-selected` : ``}`;

        isSelected
          ? optionEl.setAttribute('aria-selected', 'true')
          : optionEl.setAttribute('aria-selected', 'false');

        optionEl.innerText = option;

        optionEl.addEventListener('click', () => {
          this.onOptionClick(index);
        });

        optionEl.addEventListener('mousedown', this.onOptionMouseDown.bind(this));

        this.listboxEl.appendChild(optionEl);
      });
    };

    // Prepare options element for Multiselect list and build new options.
    Multiselect.prototype.setOptions = function (options) {
      this.options = options;
      this.listboxEl.querySelectorAll('*').forEach(n => n.remove());
      this.buildOptions(this.options);
    };

    Multiselect.prototype.onInputKeyDown = function (event) {
      const max = this.options.length - 1;
      const action = getActionFromKey(event, this.open);
      switch (action) {
        case MenuActions.Next:
        case MenuActions.Last:
        case MenuActions.First:
        case MenuActions.Previous:
          event.preventDefault();
          return this.onOptionChange(getUpdatedIndex(this.activeIndex, max, action));
        case MenuActions.CloseSelect:
          event.preventDefault();
          return this.updateOption(this.activeIndex);
        case MenuActions.Close:
          event.preventDefault();
          return this.updateMenuState(false);
        case MenuActions.Open:
          return this.updateMenuState(true);
      }
    };

    Multiselect.prototype.onInputBlur = function () {
      if (this.ignoreBlur) {
        this.ignoreBlur = false;
        return;
      }

      if (this.open) {
        this.updateMenuState(false, false);
      }
    };

    Multiselect.prototype.onOptionChange = function (index) {
      this.activeIndex = index;
      this.inputEl.setAttribute('aria-activedescendant', `${this.idBase}-${index}`);

      // Update active style for current option.
      const options = this.el.querySelectorAll('[role=option]');
      [...options].forEach(optionEl => {
        optionEl.classList.remove('option-current');
      });
      options[index].classList.add('option-current');

      if (this.open && isScrollable(this.listboxEl)) {
        maintainScrollVisibility(options[index], this.listboxEl);
      }
    };

    Multiselect.prototype.onOptionClick = function (index) {
      this.onOptionChange(index);
      this.updateOption(index);
      this.inputEl.focus();
    };

    Multiselect.prototype.onOptionMouseDown = function () {
      this.ignoreBlur = true;
    };

    Multiselect.prototype.removeOption = function (index) {
      const option = this.options[index];

      // Update aria-selected when option is added back to the Multiselect list.
      const options = this.el.querySelectorAll('[role=option]');
      options[index].setAttribute('aria-selected', 'false');
      options[index].classList.remove('option-selected');
      options[index].setAttribute('disabled', 'false');

      // Remove button from selected options.
      const buttonEl = document.getElementById(`${this.idBase}-remove-${index}`);
      this.selectedEl.removeChild(buttonEl.parentElement);
    };

    Multiselect.prototype.selectOption = function (index) {
      const selected = this.options[index];
      this.activeIndex = index;
      // Update aria-selected when option is selected from the Multiselect list.
      const options = this.el.querySelectorAll('[role=option]');
      options[index].setAttribute('aria-selected', 'true');
      options[index].setAttribute('disabled', 'true');
      options[index].classList.add('option-selected');

      // Add remove option button HTML for each option selected.
      const buttonEl = document.createElement('button');
      const listItem = document.createElement('li');
      buttonEl.className = 'remove-option';
      buttonEl.type = 'button';
      buttonEl.id = `${this.idBase}-remove-${index}`;
      buttonEl.setAttribute('aria-describedby', `${this.idBase}-remove`);
      const listener = function (e) {
        let filterValue = options[index].innerText;
        if (this.exclude) {
          this.helper.removeFacetExclusion('ingredients_base', filterValue).search();
        } else {
          this.helper.removeFacetRefinement('ingredients_base', filterValue).search();
        }
        this.removeOption(index);
      };
      buttonEl.addEventListener('click', listener.bind(this));
      buttonEl.innerHTML = selected + ' ';
      if (this.exclude) {
        this.helper.addFacetExclusion('ingredients_base', options[index].innerText).search();
      } else {
        this.helper.addFacetRefinement('ingredients_base', options[index].innerText).search();
      }
      listItem.appendChild(buttonEl);
      this.selectedEl.appendChild(listItem);
    };

    Multiselect.prototype.updateOption = function (index) {
      const option = this.options[index];
      const optionEl = this.el.querySelectorAll('[role=option]')[index];
      const isSelected = optionEl.getAttribute('aria-selected') === 'true';
      if (isSelected) {
        this.removeOption(index);
      } else {
        this.selectOption(index);
      }
      this.inputEl.value = '';
    };

    Multiselect.prototype.updateMenuState = function (open, callFocus = true) {
      this.open = open;

      this.inputEl.setAttribute('aria-expanded', `${open}`);
      open ? this.el.classList.add('open') : this.el.classList.remove('open');
      callFocus && this.inputEl.focus();
    };

    // Initialize multiselect objects for use elsewhere.
    const multiselectEl = document.querySelector(multiElement);
    const multiselectComponent = new Multiselect(multiselectEl, multiOptions, helper, exclude);

    return multiselectComponent;
  };

  Drupal.theme.search_index_tab = (index, label, i) => {
    // Put the active class on the first tab automatically.
    let tabClassList = i == true ? 'tabindex active' : 'tabindex';
    let ariaSelected = i == true ? 'true' : 'false';
    return `<a aria-selected="${ariaSelected}" role="tab" aria-controls="${index}" href="#" class="${tabClassList}" id="index_tab_${index}" data-index="${index}">${label}<span class="results_count"></span></a>`;
  };

  Drupal.theme.search_set_tab = self => {
    let hash = window.location.hash;
    if (hash) {
      hash = hash.substring(1);
      let tab = [...document.querySelectorAll('#algolia_container #tabs .tabindex')].filter(
        tab => hash === tab.getAttribute('data-index')
      )[0];
      tab = !tab ? document.querySelectorAll('#algolia_container #tabs .tabindex')[0] : tab;
      document.querySelectorAll('#algolia_container #tabs .tabindex').forEach(tab => {
        tab.setAttribute('aria-selected', 'false');
        tab.classList.remove(Drupal.theme.kabSearchClasses.active);
      });
      document.querySelectorAll('#algolia_results .index_results').forEach(results => {
        results.classList.remove(Drupal.theme.kabSearchClasses.activeTab);
      });
      let activeOption = tab.getAttribute('data-idx');
      tab.setAttribute('aria-selected', 'true');
      tab.classList.add(Drupal.theme.kabSearchClasses.active);
      self.mobileSelectTabs.onOptionChange(activeOption);
      self.mobileSelectTabs.selectOption(activeOption);
      self.mobileSelectTabs.updateMenuState(false);
      document
        .querySelectorAll(`#algolia_results #${hash}`)
        .forEach(results => results.classList.add(Drupal.theme.kabSearchClasses.activeTab));
    }
  };

  // Render All Index see all index buttons in hits header.
  Drupal.theme.seeAllIndexButtons = function (self, event) {
    event.preventDefault();

    document.querySelectorAll('#algolia_container #tabs .tabindex').forEach(tab => {
      tab.setAttribute('aria-selected', 'false');
      tab.classList.remove(Drupal.theme.kabSearchClasses.active);
    });

    document.querySelectorAll('#algolia_results .index_results').forEach(results => {
      results.classList.remove(Drupal.theme.kabSearchClasses.activeTab);
    });

    let tab = [...document.querySelectorAll('#algolia_container #tabs .tabindex')].filter(
      tab =>
        event.target.dataset.index === tab.dataset.index
    )[0];

    // Set active class on the active tab.
    tab.setAttribute('aria-selected', 'true');
    tab.classList.add(Drupal.theme.kabSearchClasses.active);

    // Set value of mobile dropdown tab styling.
    let activeOption = tab.getAttribute('data-idx');
    let tabindex = tab.getAttribute('data-index');

    // Update url to display the current selected index on mobile or desktop.
    if (history.pushState) {
      history.pushState(null, null, `#${tab.getAttribute('data-index')}`);
    } else {
      window.location.hash = `#${tab.getAttribute('data-index')}`;
    }

    // Update mobile options to set active index.
    self.mobileSelectTabs.onOptionChange(activeOption);
    self.mobileSelectTabs.selectOption(activeOption);
    self.mobileSelectTabs.updateMenuState(false);

    // Make we do not scroll to hash link and stay at the top of the page.
    window.scrollTo(0, 0);

    // Set active index tab.
    const activePanel = document.querySelector(`#algolia_results #${tabindex}`);
    activePanel.classList.add(Drupal.theme.kabSearchClasses.activeTab);
  };

  Drupal.behaviors.searchResults = {
    attach(context, settings) {
      if (context !== document || this.initialized) {
        return;
      }

      this.container = document.querySelector('#algolia_container');

      if (!this.container) {
        return;
      }

      /**
       * Extract query parameter to send to Dynamic Yield.
       */
      let searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has('query')) {
        Drupal.behaviors.kafGaTracking.trackSearchQuery(searchParams.get('query'));
      }

      /**
       * Initialize Algolia search client.
       */
      const algoliaClient = algoliasearch(
        drupalSettings.kaf_search.algolia_app_id,
        drupalSettings.kaf_search.algolia_api_key
      );

      // Proxy search wrapper so we can avoid empty searches.
      this.searchClient = {
        ...algoliaClient,
        search(requests) {
          if (requests.every(({ params }) => !params.query)) {
            // No query; return empty result without pinging Algolia.
            return Promise.resolve({
              results: requests.map(() => ({
                hits: [],
                nbHits: 0,
                nbPages: 0,
                page: 0,
                processingTimeMS: 0,
              })),
            });
          }
          const newRequests = requests.map(request => {
            // Scope empty string and asterisk out of search analytics.
            if (
              !request.params.query ||
              request.params.query.length == 0 ||
              request.params.query == '*'
            ) {
              request.params.analytics = false;
            }
            return request;
          });

          return algoliaClient.search(newRequests);
        },
      };

      const pageIndex =
        this.getUrlIndex() ||
        Drupal.kafHelper.checkIndex(document.querySelector('#algolia_container').getAttribute('data-algolia-index'));
      const pageFilter = drupalSettings.kaf_search.filter || null;
      const idxs = this.getIndices();

      if (!pageIndex && !pageFilter) {
        /**
         * Initilize main and index results pages.
         */
        this.initializeIs(this.getIndices().shift().index);
        this.initializeMain();
        this.container
          .querySelector('#all_indices')
          .classList.add(Drupal.theme.kabSearchClasses.activeTab);
      } else {
        // Get index object for the particular pageIndex.
        let pageId = idxs.filter(indexObj => indexObj.index === pageIndex)[0];

        // Initilize index for pageIndex search results.
        this.initializeIs(pageId.index);

        // Create container for pageIndex search results.
        this.container.querySelector('#algolia_results').innerHTML +=
          Drupal.theme.search_index_results(pageId.index);

        // Initialize pageIndex results filters and widgets.
        this.initializeIndex(pageId, pageFilter);

        // If we are on the pageIndex results page show div.
        const indexResults = document.querySelector('.index_results');
        if (indexResults) {
          indexResults.style.display = 'block';
        }
      }

      /** Initialize tab methods. */
      if (!this.hideTabs()) {
        this.getIndices().forEach(indexObj => {
          /** Initialize tabs for other indexes. */
          this.initializeTab(indexObj);
          /** Add specific results containers for other indexes. */
          this.container.querySelector('#algolia_results').innerHTML +=
            Drupal.theme.search_index_results(indexObj.index);
        });

        /** Initialize Algolia for other indexes. */
        idxs.forEach(indexObj => this.initializeIndex(indexObj));

        /** Add index attribute to tabs. */
        const tabs = [...document.querySelectorAll('#algolia_container #tabs a')];
        tabs.forEach((element, index) => element.setAttribute('data-idx', index));

        /** Create select list for mobile tab navigation. */
        Drupal.theme.search_index_tab_select_list(
          '.js-select',
          [...document.querySelectorAll('.tabindex')].map(opt => opt.innerText),
          [],
          () => {},
          ''
        );

        // On page load set correct tab based off hash in url.
        Drupal.theme.search_set_tab(this);
      }

      if (this.hideTabs()) {
        const searchTabsContainer = document.querySelector('.search-tabs--container');
        if (searchTabsContainer) {
          searchTabsContainer.style.display = 'none';
        }
      }

      // Start instant search instance for pageIndex results.
      this.is.start();

      // Add event listeners to document.
      this.attachHandlers();

      // Add missing aria attributes
      this.addAria();

      // Initialization has been completed.
      this.initialized = true;

      // On document load check if there is a hash in the url
      // if so this will prevent the page from jumping that id.
      if (location.hash) {
        setTimeout(() => window.scrollTo(0, 0), 1);
      }

      // On document load set focus to search input.
      const searchInput = document.querySelector('.ais-SearchBox-input');
      if (searchInput) {
        window.setTimeout(function () {
          searchInput.focus();
        }, 5);
      }

      // Temporary fix for search overlay issue on search results page
      // Set overlay button to display none
      const searchResultsBlock = document.getElementById('block-kafalgoliasearchresults');
      if (searchResultsBlock) {
        const searchButton = document.querySelector('.menu--utility .search');
        if (searchButton) {
          searchButton.style.display = 'none';
        }
      }
    },

    /**
     * Initilize the main / multiindex results view.
     */
    initializeMain() {
      let indices = this.getIndices();

      this.initializeTab({ index: 'all_indices', label: 'All' }, true);
      this.container.querySelector('#algolia_results').innerHTML +=
        Drupal.theme.search_all_results(indices);

      const primary = indices.shift();

      const is = this.is;

      const customSearchBox = instantsearch.connectors.connectSearchBox(this.customInput());

      is.addWidget(
        customSearchBox({
          container: document.querySelector('#algolia_container .sbox'),
        })
      );

      is.addWidget(instantsearch.widgets.configure({ hitsPerPage: 4 }));

      const primaryHits = instantsearch.connectors.connectHits(primary.render);

      is.addWidget(
        instantsearch.widgets
          .index({
            indexName: primary.index,
            indexId: `all_results_${primary.index}`,
          })
          .addWidgets([primaryHits({ container: `all_indices #${primary.index}_hits` })])
      );

      const renderMoreButton = ({ nbHits, widgetParams, query }, isFirstRender) => {
        let currentQuery = this.getUrlQuery() !== '' && query === '' ? this.getUrlQuery() : query;
        if (currentQuery) {
          if (nbHits > 0) {
            document.querySelector(
              '#algolia_results #' + widgetParams.container
            ).parentNode.children[0].innerHTML = `<div class="grid-item-title">"${currentQuery}" in ${widgetParams.label}</div>`;
          } else {
            document.querySelector(
              '#algolia_results #' + widgetParams.container
            ).parentNode.children[0].innerHTML = ``;
          }
        } else {
          document.querySelector(
            '#algolia_results #' + widgetParams.container
          ).parentNode.children[0].innerHTML = `<h4>${widgetParams.label}</h4>`;
        }

        if (nbHits > 4) {
          const seeAllLabel = widgetParams.label === 'Other' ? 'Results' : widgetParams.label;
          document.querySelector('#algolia_results #' + widgetParams.container).innerHTML = `
            <a class="button search-page-see-all" data-index="${widgetParams.index}" href="#">See all ${nbHits} ${seeAllLabel}</a>
          `;
          document.querySelector('#algolia_results #' + widgetParams.container).style.display =
            'block';

          // Add events to the .hits_header button, Algolia has not rendered until now.
          [...document.querySelectorAll('.hits_header a')].forEach(button =>
            button.addEventListener('click', event => Drupal.theme.seeAllIndexButtons(this, event))
          );
        } else {
          document.querySelector('#algolia_results #' + widgetParams.container).innerHTML = ``;
          document.querySelector('#algolia_results #' + widgetParams.container).style.display =
            'none';
        }
      };

      const statsMoreButton = instantsearch.connectors.connectStats(renderMoreButton);

      is.addWidget(
        statsMoreButton({
          container: `all_indices #bc_product_index_hits .hits_header`,
          index: 'bc_product_index',
          label: 'Products',
        })
      );

      indices.map(({ index, render, label }) => {
        const customHits = instantsearch.connectors.connectHits(render);
        is.addWidget(
          instantsearch.widgets
            .index({ indexName: index, indexId: `all_results_${index}` })
            .addWidgets([
              customHits({ container: `all_indices #${index}_hits` }),
              statsMoreButton({
                container: `all_indices #${index}_hits .hits_header`,
                index: index,
                label: label,
              }),
            ])
        );
      });
    },

    /**
     * Initilize the index specific tab results views.
     */
    initializeTab({ index, label }, active) {
      active = active || false;
      document.querySelector('#algolia_container #tabs').innerHTML += Drupal.theme.search_index_tab(
        index,
        label,
        active
      );
    },

    /**
     * Initilize index specific results widgets.
     */
    initializeIndex({ label, index, render, filters, ingredientFilter }, pageFilter) {
      const container = index;
      const indexWidget = instantsearch.widgets.index({
        indexName: index,
        indexId: `main_results_${index}`,
      });

      // Add custom widgets to other indexes.
      const customHits = instantsearch.connectors.connectHits(render);
      const customResults = instantsearch.connectors.connectStats(
        this.renderCurrentResults(label, index)
      );
      const customActiveFilters = instantsearch.connectors.connectCurrentRefinements(
        this.renderActiveFilters()
      );

      const customSortBy = instantsearch.connectors.connectSortBy(
        this.customRenderSortBy(container)
      );

      let sortByItems = [];

      switch (true) {
        case container === 'bc_product_index':
          sortByItems = [
            { label: 'Relevance', value: 'bc_product_index' },
            { label: 'Price: (low to high)', value: 'bc_product_price_asc' },
            { label: 'Price: (high to low)', value: 'bc_product_price_desc' },
            { label: 'Rating: (low to high)', value: 'bc_product_rating_asc' },
            { label: 'Rating: (high to low)', value: 'bc_product_rating_desc' },
          ];
          break;

        case container === Drupal.kafHelper.checkIndex('recipe_index'):
          sortByItems = [
            { label: 'Relevance', value: Drupal.kafHelper.checkIndex('recipe_index') },
            {
              label: 'Rating: (low to high)',
              value: `${Drupal.kafHelper.checkIndex('recipe_index')}_rating_asc`,
            },
            {
              label: 'Rating: (high to low)',
              value: `${Drupal.kafHelper.checkIndex('recipe_index')}_rating_desc`,
            },
          ];
          break;

        default:
          sortByItems = [];
          break;
      }

      indexWidget.addWidgets([

        instantsearch.widgets.queryRuleCustomData({
          container: '#algolia-query-rule',
          templates: {
            default: '',
          },
          transformItems(items) {
            const match = items.find(data => Boolean(data.redirect));
            if (match && match.redirect) {
              window.location.href = match.redirect;
            }

            const promo = items.find(data => Boolean(data.promo_block));
            if (promo && promo.promo_block) {
              const banner_id = promo.promo_block;
              const res = Drupal.ajax({
                url: `/ajax/search/promo/${container}/${banner_id}`,
              }).execute();
            }

            return [];
          },
        }),

        instantsearch.widgets.pagination({
          container: '#algolia_results #' + container + ' .pagination',
          scrollTo: document.querySelector('#algolia_results'),
          padding: 2,
        }),

        instantsearch.widgets.configure({ hitsPerPage: 24 }),

        customResults({
          container: document.querySelector('#algolia_results #' + container + ' .current_results'),
        }),

        customActiveFilters({
          container: document.querySelector('#algolia_results #' + container + ' .active_filters'),
          excludedAttributes: ['ingredients_base'],
        }),

        customHits({ container: container }),
      ]);

      this.initializeIndexFilters(indexWidget, container, filters, this);

      if (!!ingredientFilter) {
        indexWidget.addWidgets([
          this.ingredientsWidget(container, false),
          this.ingredientsWidget(container, true),
        ]);

        if (pageFilter) {
          indexWidget.addWidgets([
            instantsearch.widgets.configure({
              hierarchicalFacets: [
                {
                  name: 'category',
                  attributes: ['category_lvl0', 'category_lvl1'],
                },
              ],
              hierarchicalFacetsRefinements: pageFilter,
            }),
          ]);
        }
      }

      if (
        container !== Drupal.kafHelper.checkIndex('blog_index') &&
        container !== Drupal.kafHelper.checkIndex('general_content_index')
      ) {
        const filterDiv = document.createElement('div');
        filterDiv.setAttribute('class', 'sort-by-mobile-container sort-by-' + container);
        const filters = document.querySelector(
          '#algolia_results #' + container + ' .filters .mobile-filters--container'
        );
        filters.appendChild(filterDiv);

        indexWidget.addWidgets([
          customSortBy({
            container: document.querySelector('#algolia_results #' + container + ' .sort_results'),
            items: sortByItems,
          }),

          customSortBy({
            container: document.querySelector(
              '#algolia_results #' + container + ' .filters .sort-by-' + container
            ),
            items: sortByItems,
          }),
        ]);
      }

      this.is.addWidget(indexWidget);
    },

    customHierarchicalMenu() {
      const renderList = ({ items, createURL }, subList, isAnyRefined) => `
  <ul class="ais-HierarchicalMenu-list ${isAnyRefined ? `hide-unrefined` : `show-unrefined`}">
    ${items
      .map(item => {
        let setClass = '';
        if (item.isRefined && !subList) {
          setClass = 'ais-HierarchicalMenu-item--selected ais-HierarchicalMenu-item--parent';
        }
        if (item.isRefined && subList) {
          setClass = 'ais-HierarchicalMenu-item--selected';
        }
        return ` <li class="ais-HierarchicalMenu-item ${setClass} ${
          item.isRefined ? `refined` : `not-refined`
        }">
            <div>
              <a
                class="ais-HierarchicalMenu-link"
                href="${createURL(item.value)}"
                data-value="${item.value}"
              >
                <span class='ais-HierarchicalMenu-label'>${item.label}</span>
                <span class='ais-HierarchicalMenu-count'>${item.count}</span>
              </a>
            </div>
            ${
              item.data && item.data.length > 0
                ? `<div class="ais-HierarchicalMenu-list--child"> ${renderList(
                    {
                      items: item.data,
                      createURL,
                    },
                    true
                  )}</div>`
                : ''
            }
          </li>
        `;
      })
      .join('')}
  </ul>
`;

      const renderHierarchicalMenu = (renderOptions, isFirstRender) => {
        const { items, refine, createURL, widgetParams } = renderOptions;

        if (isFirstRender) {
          const list = document.createElement('div');
          list.setAttribute('class', 'ais-HierarchicalMenu');
          widgetParams.container.appendChild(list);
        }

        const isAnyRefined = items.filter(item => item.isRefined === true).length > 0;

        const children = renderList({ items, createURL }, false, isAnyRefined);

        widgetParams.container.querySelector('div').innerHTML = children;

        [...widgetParams.container.querySelectorAll('.ais-HierarchicalMenu-item  a')].forEach(
          element => {
            element.addEventListener('click', event => {
              event.preventDefault();
              const link = event.target.closest('a');
              refine(link.dataset.value);
            });
          }
        );
      };

      return renderHierarchicalMenu;
    },

    customInput() {
      // Create a render function
      const renderSearchBox = (renderOptions, isFirstRender) => {
        const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;

        if (isFirstRender) {
          const form = document.createElement('form');
          form.setAttribute('role', 'search');
          form.setAttribute('class', 'ais-SearchBox-form');
          form.setAttribute('novalidate', '');
          form.setAttribute('method', 'POST');
          form.setAttribute('action', window.location.href);

          const input = document.createElement('input');
          input.setAttribute('placeholder', '');
          input.setAttribute('class', 'ais-SearchBox-input');
          input.setAttribute('autocomplete', 'off');
          input.setAttribute('autocorrect', 'off');
          input.setAttribute('autocapitalize', 'off');
          input.setAttribute('aria-label', 'Search results input');
          input.setAttribute('maxlength', '512');

          const button = document.createElement('button');
          button.setAttribute('type', 'submit');
          button.setAttribute('title', 'Submit the search query.');
          button.setAttribute('class', 'ais-SearchBox-submit');

          input.addEventListener('input', event => {
            if (event.target.value.length > 2) {
              refine(event.target.value);
              form.setAttribute('action', window.location.href);
            }
          });

          input.addEventListener('keydown', () => {
            form.setAttribute('action', window.location.href);
          });

          form.addEventListener('submit', event => {
            event.preventDefault();
            refine(input.value);
            form.setAttribute('action', window.location.href);
          });

          form.appendChild(input);
          form.appendChild(button);
          widgetParams.container.appendChild(form);
        }
        if (!widgetParams.container.querySelector('input').value) {
          widgetParams.container.querySelector('input').value = query;
        }
      };

      return renderSearchBox;
    },

    customRenderSortBy(index) {
      const renderSortBy = (renderOptions, isFirstRender) => {
        const { options, currentRefinement, hasNoResults, refine, widgetParams } = renderOptions;

        const uniqueId =
          widgetParams.container.getAttribute('class').indexOf('sort-by-mobile-container') !== -1
            ? 'mobile'
            : 'desktop';

        if (isFirstRender) {
          const selectList = document.createRange().createContextualFragment(`
                <div class="${index}-select sort-by">
                  <div
                      aria-activedescendant="sort-by-${index}-${uniqueId}-value"
                      aria-controls="listbox-${index}-${uniqueId}"
                      aria-expanded="false"
                      aria-labelledby="sort-by-${index}-${uniqueId}-label"
                      id="sort-by-${index}-${uniqueId}"
                      class="sort-by-input"
                      role="combobox"
                      tabindex="0"
                      aria-owns="listbox-${index}-${uniqueId}"
                      >
                    <div
                       role="textbox"
                       aria-readonly="true"
                       aria-label="Sort by label"
                       class="sort-by-label"
                       id="sort-by-${index}-${uniqueId}-label"
                       >
                       Sort By
                    </div>
                    <span
                       role="textbox"
                       aria-readonly="true"
                       aria-label="Sort by value"
                       class="sort-by-value"
                       id="sort-by-${index}-${uniqueId}-value">
                    </span>
                  </div>
                  <div class="sort-by-menu" role="listbox" id="listbox-${index}-${uniqueId}"></div>
                </div>
                `);

          widgetParams.container.appendChild(selectList);

          Drupal.theme.search_index_tab_select_list(
            `.${index}-select`,
            options.map(opt => opt.label),
            options.map(opt => opt.value),
            refine,
            currentRefinement
          );

          refine(currentRefinement);
        }
      };

      return renderSortBy;
    },

    /**
     * Render results for other indexes custom render function.
     */
    renderCurrentResults(label, index) {
      const renderStats = (renderOptions, isFirstRender) => {
        const { query, nbHits, widgetParams } = renderOptions;

        if (isFirstRender) {
          return;
        }

        const tabContainer = document.querySelector('#tabs #index_tab_' + index);

        if (tabContainer) {
          if (nbHits === 0) {
            tabContainer.classList.add('no--results');
          } else {
            tabContainer.classList.remove('no--results');
          }
          tabContainer.querySelector('.results_count').textContent = `(${nbHits})`;
          document
            .querySelectorAll('.mobile-search-tabs--container .combo-menu .combo-option')
            .forEach(comboOption => {
              if (comboOption.firstChild.textContent === label) {
                let resultsCount = comboOption.querySelector('.results_count');
                if (!resultsCount) {
                  resultsCount = document.createElement('span');
                  resultsCount.classList.add('results_count');
                  comboOption.appendChild(resultsCount);
                }
                resultsCount.textContent = `(${nbHits})`;
              }
            });
        }

        const queryText =
          query !== '' && query !== '*'
            ? `<span class="query--container">"${query}" in</span> `
            : ``;

        let count = '';
        if (nbHits > 1) {
          count += `${queryText}${label} <span class="hits--container">(${nbHits})</span>`;
        } else if (nbHits === 1) {
          count += `${queryText}${label} (1)`;
        } else {
          count += `no result`;
        }

        widgetParams.container.innerHTML = `<div aria-live="polite" class="h1--search-results">${count}</div>`;
      };

      return renderStats;
    },

    /**
     * Render current refinements for other indexes custom render function.
     */
    renderActiveFilters() {
      const createDataAttributes = refinement =>
        Object.keys(refinement)
          .map(key => `data-${key}="${refinement[key]}"`)
          .join(' ');

      const renderListItem = item => `
              <ul class="ais-CurrentRefinements-list">
                ${item.refinements
                  .map(
                    refinement => `<li class="ais-CurrentRefinements-item">
                        <span class="ais-CurrentRefinements-category">
                        <button class="ais-CurrentRefinements-delete" ${createDataAttributes(
                          refinement
                        )} aria-label="Remove filter: ${refinement.label} ${
                      refinement['attribute'].toLowerCase().indexOf('rating') !== -1 ? `stars` : ``
                    }">
                        <span class="ais-CurrentRefinements-categoryLabel">${
                          refinement['attribute'].toLowerCase().indexOf('rating') !== -1
                            ? refinement.label.indexOf('5') !== -1
                              ? `${refinement.label}`
                              : `${refinement.label} & up`
                            : `${refinement.label}`
                        }</span>&nbsp;<span class="ais-CurrentRefinements-close"></span></button>
                        </span>
                      </li>`
                  )
                  .join('')}
              </ul>

          `;

      const renderCurrentRefinements = (renderOptions, isFirstRender) => {
        const { items, refine, widgetParams } = renderOptions;

        widgetParams.container.innerHTML = `<div class="ais-CurrentRefinements">${items
          .map(item =>
            item.indexName.indexOf(widgetParams.container.getAttribute('data-index')) !== -1
              ? renderListItem(item)
              : ``
          )
          .join('')}</div>`;

        [...widgetParams.container.querySelectorAll('button')].forEach(element => {
          element.addEventListener('click', event => {
            const item = Object.keys(event.currentTarget.dataset).reduce(
              (acc, key) => ({
                ...acc,
                [key]: event.currentTarget.dataset[key],
              }),
              {}
            );

            refine(item);
          });
        });
      };

      return renderCurrentRefinements;
    },

    /**
     * Initialize index filters.
     */
    initializeIndexFilters(parent, container, filters, self) {
      const types = {
        numericMenu: {
          items: [
            { label: 'All' },
            { label: 'Less than $5', end: 5 },
            { label: '$5 - $10', start: 5, end: 10 },
            { label: '$10 - $20', start: 10, end: 20 },
            { label: '$20 - $50', start: 20, end: 50 },
            { label: '$50 - $100', start: 50, end: 100 },
            { label: 'Over $100', start: 100 },
          ],
        },
        ratingMenu: {
          templates: {
            item: `
              {{#count}}
                <a class="{{cssClasses.link}}" aria-label="{{value}} stars & up" href="{{href}}">
                <div class="rating rating-is-{{value}}"></div>
              {{/count}}
              {{^count}}
                <div class="{{cssClasses.link}}" aria-label="{{value}} stars & up" disabled>
                <div class="rating rating-is-{{value}}"></div>
              {{/count}}
              {{#count}}
                <span class="{{cssClasses.count}}">& up</span>
              {{/count}}
              {{#count}}
                </a>
              {{/count}}
              {{^count}}
                </div>
              {{/count}}
            `,
          },
        },
        hierarchicalMenu: {
          sortBy: ['isRefined', 'name:asc'],
          showParentLevel: true,
          limit: 15,
        },
        refinementList: {
          templates: {
            item: `
               <label class="ais-RefinementList-label">
                 <input type="checkbox" class="ais-RefinementList-checkbox" value="{{label}}" {{#isRefined}}checked{{/isRefined}}/>
                 <span class="ais-RefinementList-labelText">
                   <span class="ais-RefinementList-labelText-inner-container">
                     {{label}} ({{count}})
                   </span>
                 </span>
               </label>
            `,
          },
          operator: 'and',
        },
      };

      filters = filters || [];
      filters.forEach(filter => {
        let { id, label, attr, type } = filter;
        type = type || 'refinementList';
        const filterConfig = filter.config || {};
        const filterRemove = filter.remove || false;
        const typeConfig = types[type]
          ? Object.assign({}, types[type], filterConfig)
          : filterConfig;

        const fid = `${container}_filters_${id}`;

        if (!filterRemove) {
          let filterLink = document.createElement('a');
          filterLink.classList.add('search-filter-label');
          filterLink.setAttribute('href', '#');
          filterLink.setAttribute('aria-expanded', 'false');
          filterLink.innerHTML = `<span>${label}</span>`;
          const filterContainer = document.querySelector(
            `#algolia_results #${container} .filters .mobile-filters--container`
          );
          if (filterContainer) {
            filterContainer.append(filterLink);
          }
        }

        let filterDiv = document.createElement('div');
        filterDiv.classList.add('filter');
        filterDiv.classList.add('collapse');
        filterDiv.setAttribute('id', fid);

        if (filterRemove) {
          filterDiv.setAttribute('style', 'display:none');
        }

        document
          .querySelector(`#algolia_results #${container} .filters .mobile-filters--container`)
          .append(filterDiv);

        if (attr === 'ingredients') return;

        let widgetConfig = {
          container:
            type === 'hierarchicalMenu'
              ? document.querySelector(`#algolia_results #${container} #${fid}`)
              : `#algolia_results #${container} #${fid}`,
          ...typeConfig,
        };

        if (attr instanceof Array) {
          widgetConfig.attributes = attr;
        } else {
          widgetConfig.attribute = attr;
        }

        if (type === 'hierarchicalMenu') {
          // Create the custom widget.
          const customHierarchicalMenu = instantsearch.connectors.connectHierarchicalMenu(
            self.customHierarchicalMenu()
          );

          // Instantiate the custom widget.
          parent.addWidgets([customHierarchicalMenu(widgetConfig)]);
        } else {
          const widget = instantsearch.widgets[type](widgetConfig);
          parent.addWidgets([widget]);
        }
      });
    },

    /**
     * Initialize instantsearch library.
     */
    initializeIs(index) {
      const searchClient = this.searchClient;
      this.is = instantsearch({
        indexName: index,
        routing: {
          stateMapping: {
            stateToRoute(uiState) {
              const url = new URL(window.location.href);
              let currentIndex = url.hash ? url.hash.replace('#', '') : index;
              if (uiState['main_results_' + currentIndex]) {
                currentIndex = 'main_results_' + currentIndex;
              } else {
                currentIndex = 'main_results_' + index;
              }
              const indexUiState = uiState[currentIndex];
              return {
                query: uiState[index].query,
                filters: indexUiState.refinementList,
                menu: indexUiState.hierarchicalMenu,
                rating: indexUiState.ratingMenu,
                ingredients_include: indexUiState.ingredients_include,
                ingredients_exclude: indexUiState.ingredients_exclude,
                page: indexUiState.page,
              };
            },
            routeToState(routeState) {
              const url = new URL(window.location.href);
              let currentIndex = url.hash ? 'main_results_' + url.hash.replace('#', '') : index;
              let uiState = {
                [currentIndex]: {
                  query: routeState.query,
                  refinementList: routeState.filters,
                  hierarchicalMenu: routeState.menu,
                  ratingMenu: routeState.rating,
                  ingredients_include: routeState.ingredients_include,
                  ingredients_exclude: routeState.ingredients_exclude,
                  page: routeState.page,
                }
              };
              if (!uiState[index]) {
                uiState[index] = {
                  query: routeState.query,
                  page: routeState.page,
                }
              }
              return uiState;
            },
          },
        },
        insights: {},
        searchClient,
        searchFunction(helper) {
          if (this.queryInitialized){
            helper.search();
            return;
          }
          this.queryInitialized = true;
          const url = new URL(window.location.href);
          const searchParams = new URLSearchParams(url.search);
          const hasQuery = searchParams.has('query');
          const q = searchParams.get('query');
          const filterShowAll =
            drupalSettings.kaf_search.filter && !helper.state.query ? true : false;

          switch (true) {
            case hasQuery:
              // Check if there is query coming in from search overlay.
              helper.setQuery(q).search();
              break;

            case filterShowAll:
              // If page is filtered and has no query, use *.
              helper.setQuery('*').search();

            default:
              helper.search();
              break;
          }
        },
      });

      this.is.on('render', () => {
        // Remove unnecessary star symbol SVGs with duplicate IDs.
        document.querySelectorAll('.ais-RatingMenu>svg').forEach(svg => {
          svg.remove();
        });
      });
    },

    lockFocus: () => {
      const overlay = document.querySelector('.active-tab-filters');
      const focusableElements =
        'a.ais-RatingMenu-link, a.search-filter-label, a.ais-HierarchicalMenu-link, input.ais-RefinementList-checkbox, button.mobile-filters__hide,button.mobile-search-apply-button, [role=combobox]';
      const firstFocusableElement = overlay.querySelectorAll(focusableElements)[0];
      const firstFocusableElementHref = overlay.querySelectorAll(focusableElements)[1];
      const focusableContent = overlay.querySelectorAll(focusableElements);
      const lastFocusableElement = focusableContent[focusableContent.length - 1];

      document.addEventListener('keydown', e => {
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        if (!isTabPressed) {
          return;
        }

        if (e.shiftKey) {
          // if shift key pressed for shift + tab combination
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else {
          // if tab key is pressed
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      });

      firstFocusableElementHref.focus();
    },

    /**
     * Attach event handlers after display has been initialized.
     */
    attachHandlers() {
      if (!this.hideTabs()) {
        let selectTabs = this.mobileSelectTabs;

        document.querySelectorAll(`#algolia_container #tabs .tabindex`).forEach(tab => {
          tab.addEventListener('click', e => {
            e.preventDefault();

            document.querySelectorAll('#algolia_container #tabs .tabindex').forEach(tab => {
              tab.setAttribute('aria-selected', 'false');
              tab.classList.remove(Drupal.theme.kabSearchClasses.active);
            });

            if (history.pushState) {
              history.pushState(null, null, `#${e.target.getAttribute('data-index')}`);
            } else {
              window.location.hash = `#${e.target.getAttribute('data-index')}`;
            }

            // Set active class on the active index tab.
            e.target.setAttribute('aria-selected', 'true');
            e.target.classList.add(Drupal.theme.kabSearchClasses.active);

            // Set value of mobile dropdown index tab.
            let activeOption = e.target.getAttribute('data-idx');
            selectTabs.onOptionChange(activeOption);
            selectTabs.selectOption(activeOption);
            selectTabs.updateMenuState(false);

            // Set which index to show by getting the data-index attribute.
            let tabindex = e.target.getAttribute('data-index');
            document
              .querySelectorAll('#algolia_results .index_results')
              .forEach(results =>
                results.classList.remove(Drupal.theme.kabSearchClasses.activeTab)
              );
            document
              .querySelectorAll(`#algolia_results #${tabindex}`)
              .forEach(results => results.classList.add(Drupal.theme.kabSearchClasses.activeTab));
          });
        });
      }

      // Toggle open and close event for mobile refinements overlay.
      document.querySelectorAll('.mobile-search-filters-button').forEach(button => {
        button.addEventListener('click', e => {
          const activeFilter = document.querySelector(
            '.active-tab .filters, .view--recipe-category .filters'
          );

          // Set the active mobile filters.
          activeFilter.classList.add('active-tab-filters');

          // Get the current filter open button.
          const currentButton = e.target;

          // Lock focus inside mobile filters.
          this.lockFocus();

          // Add overflow hidden to body to prevent the scrolling
          // of the actual html page.
          document.body.style.overflow = 'hidden';

          // Remove all actions above.
          activeFilter.querySelector('.mobile-filters__hide').addEventListener('click', () => {
            currentButton.focus();
            activeFilter.classList.remove('active-tab-filters');
            document.body.style.overflow = '';
          });

          activeFilter
            .querySelector('.mobile-search-apply-button')
            .addEventListener('click', () => {
              let focusTarget = document.querySelector('.ais-SearchBox-input')
                ? document.querySelector('.ais-SearchBox-input')
                : document.querySelector('.index_results');
              if (focusTarget) {
                focusTarget.focus();
              }
              activeFilter.classList.remove('active-tab-filters');
              document.body.style.overflow = '';
            });
        });
      });

      // Toggle mobile filters if window.innerWidth extends passed 768 pixels.
      window.addEventListener('resize', e => {
        if (window.innerWidth > 768) {
          const activeFilter = document.querySelector('.active-tab-filters');
          if (activeFilter) {
            activeFilter.classList.remove('active-tab-filters');
          }
        }
      });

      /** Classes for open and close of accordion refinements. */
      const classes = {
        toggle: 'toggle',
        show: 'add',
        hide: 'remove',
      };

      /** Toggle function for opening and closing accordion refinements. */
      const collapse = (selector, cmd) => {
        selector.classList[classes[cmd]]('show');
      };

      /** Add event listeners to toggle open and closed for accordion refinements. */
      document.querySelectorAll('#algolia_container .search-filter-label').forEach(filter => {
        filter.addEventListener('click', event => {
          event.preventDefault();
          const filter = event.target.nextElementSibling;
          collapse(filter, 'toggle');
          event.target.classList.toggle('filter-label--clicked');
          event.target.ariaExpanded = event.target.ariaExpanded === 'true' ? 'false' : 'true';
        });
      });

      const openFirstFilterAndSetTabIndex = filters => {
        if (!filters) return;
        filters.forEach(filter => {
          const filterLabels = filter.querySelectorAll('.search-filter-label');
          const firstFilter = filterLabels[0];
          if (!firstFilter) {
            return;
          }
          firstFilter.classList.add('first-filter');
          collapse(firstFilter.nextElementSibling, 'toggle');
          firstFilter.classList.toggle('filter-label--clicked');
          firstFilter.nextElementSibling.classList.add('show');
          firstFilter.ariaExpanded = 'true';
        });
      };

      openFirstFilterAndSetTabIndex(document.querySelectorAll('#algolia_container .filters'));

      // Checkboxes have somehow lost their native keyboard accessibility.
      document.addEventListener('keydown', event => {
        if (
          event.target.className.includes('ais-RefinementList-checkbox') &&
          event.code === 'Enter'
        ) {
          event.target.click();
        }
      });
    },

    /**
     * Hide results tabs for collection and filtered type pages.
     */
    hideTabs() {
      const results = new RegExp('[?&]hide-tabs=1').exec(window.location.href);
      const pageFilter = drupalSettings.kaf_search.filter || null;

      if (results || pageFilter) {
        return true;
      }

      return false;
    },

    /**
     * Get specific search index for display from inbound URL.
     */
    getUrlIndex() {
      const results = new RegExp('[?&]algolia-index=([^&#]*)').exec(window.location.href);
      if (results) {
        return decodeURI(results[1]) || null;
      }

      return null;
    },

    /**
     * Get search query from inbound URL.
     */
    getUrlQuery() {
      const urlParams = new URLSearchParams(window.location.search);
      const query = urlParams.getAll('query')[0] !== undefined ? urlParams.getAll('query')[0] : '';
      return query;
    },

    /**
     * Add Aria accessability attributes after render.
     */
    addAria() {
      // After elements have been rendered add missing accessibility attributes.
      const searchbox = document.querySelector('.ais-SearchBox-input');

      if (searchbox) {
        searchbox.setAttribute('name', 'search-results-page-input');
        searchbox.setAttribute('aria-label', 'Search results input');
      }

      const hitsPerPageSelect = document.querySelectorAll('.ais-HitsPerPage-select');

      if (hitsPerPageSelect) {
        [...hitsPerPageSelect].forEach(element => {
          element.setAttribute('aria-label', 'Items per page');
        });
      }
    },

    /**
     * Utility function to retrieve single index definition.
     */
    getIndex(index) {
      return this.getIndices()
        .filter(i => {
          return i.index === index;
        })
        .shift();
    },

    /**
     * Indices definitions and configuration.
     */
    getIndices() {
      return [
        {
          index: 'bc_product_index',
          label: 'Products',
          render: this.renderProductHits,
          filters: [
            {
              id: 'category',
              label: 'Category',
              attr: ['categoryLvl1', 'categoryLvl2'],
              type: 'hierarchicalMenu',
            },
            {
              id: 'floorRoundRating',
              label: 'Ratings',
              attr: 'floorRoundRating',
              type: 'ratingMenu',
            },
          ],
        },
        {
          index: Drupal.kafHelper.checkIndex('recipe_index'),
          label: 'Recipes',
          render: this.renderRecipeHits,
          ingredientFilter: true,
          filters: [
            {
              id: 'category',
              label: 'Category',
              attr: ['category_lvl0', 'category_lvl1'],
              type: 'hierarchicalMenu',
            },
            { id: 'filter-by-ingredient', label: 'Filter by Ingredient', attr: 'ingredients' },
            {
              id: 'diet_nutrition',
              label: 'Diet And Nutrition',
              attr: 'diet_nutrition',
            },
            { id: 'methods', label: 'Methods', attr: 'methods' },
            { id: 'occasions', label: 'Occasions', attr: 'occasions' },
            { id: 'flavors', label: 'Flavors', attr: 'flavors' },
            {
              id: 'rounded_rating',
              label: 'Ratings',
              attr: 'rounded_rating',
              type: 'ratingMenu',
            },
          ],
        },
        {
          index: Drupal.kafHelper.checkIndex('blog_index'),
          label: 'Blogs',
          render: this.renderDefaultHits,
          filters: [
            { id: 'category', label: 'Category', attr: 'category' },
            { id: 'tags', label: 'Tags', attr: 'tags' },
          ],
        },
        {
          index: Drupal.kafHelper.checkIndex('parent_class_index'),
          label: 'Classes',
          render: this.renderDefaultHits,
          filters: [
            { id: 'kaf_parent_class_location', label: 'Location', attr: 'kaf_parent_class_location' },
            { id: 'class_category', label: 'Category', attr: 'class_category' },
            { id: 'class_tag', label: 'Tags', attr: 'class_tag' },
          ],
        },
        {
          index: Drupal.kafHelper.checkIndex('general_content_index'),
          label: 'Other',
          render: this.renderDefaultHits,
          filters: [
            {
              id: 'type',
              label: 'Filter By Content',
              attr: 'type',
            },
          ],
        },
      ];
    },

    /**
     * Custom hits rendering for product type results.
     */
    renderProductHits: ({ hits, widgetParams, sendEvent }, isFirstRender) => {
      if (isFirstRender) {
        document.querySelector('#algolia_results #' + widgetParams.container + ' .hits').innerHTML =
          '<h4>' + Drupal.t('Searching...') + '</h4>';
        return;
      }

      if (hits.length == 0) {
        document.querySelector('#algolia_results #' + widgetParams.container + ' .hits').innerHTML =
          '<h4>No product matched your search term.</h4>';
        return;
      }

      // Create Add to Cart base url.
      const shopDefaultUrl = 'https://shop.kingarthurbaking.com';
      const shopActualUrl =
        (drupalSettings &&
          drupalSettings.kabBigCommerce &&
          drupalSettings.kabBigCommerce.apiBaseUrl) ??
        shopActualUrl;

      document.querySelector('#algolia_results #' + widgetParams.container + ' .hits').innerHTML = `
        ${hits
          .map(
            (item, index) => `
          <div class="grid__item product--grid-item"  style="order: ${index + 1};">
            <div class="product--inner-grid-item">
            <div class="product--top">
            <a href="${
              item.url.replace(shopDefaultUrl, shopActualUrl) || '#'
            }" class="product--details-link" data-hits-index="${index}">
              <div class="article article--simple search-result--product">
                ${
                  item.freeShip == 'Y' || item.freeShip == 1
                    ? '<div class="product-flag free_shipping">' +
                      Drupal.t('Free Shipping') +
                      '</div>'
                    : ''
                }
                ${
                  item.clearance == 'Y' || item.clearance == 1
                    ? '<div class="product-flag clearance">' + Drupal.t('Clearance') + '</div>'
                    : ''
                }
                ${
                  item.onSale == 1
                    ? '<div class="product-flag on_sale">' + Drupal.t('Sale') + '</div>'
                    : ''
                }
                ${
                  item.specialSavings == 'Y' || item.specialSavings == 1
                    ? '<div class="product-flag special">' + Drupal.t('Special Savings') + '</div>'
                    : ''
                }
                <figure class="result--image">
                  <img src="${
                    item.hasOwnProperty('thumbnail') && item.thumbnail && item.thumbnail != 'null'
                      ? item.thumbnail
                      : '/themes/custom/kaf_nextgenweb/images/no-search-image.png'
                  }" alt="" />
                </figure>
                <div class="article__content${
                  item.objectID.startsWith('VG') ? ' product-variant-parent' : ''
                }">
                  <div class="product-result-topline">
                    <div class="result-rating">
                      ${
                        item.ratingStars
                          ? '<div class="rating rating-is-' +
                            /* Remove excess precision. */
                            Math.round(item.ratingStars * 2) * 5 +
                            '">' +
                            item.ratingStars.toFixed(1) +
                            '</div> <span class="visually-hidden"> out of 5 stars</span>'
                          : ''
                      }
                      <div class="rating-count">${
                        item.ratingCount > 0
                          ? '(' +
                            item.ratingCount +
                            '<span class="visually-hidden"> Reviews</span>)'
                          : Drupal.t('Not Yet Reviewed')
                      }</div>
                    </div>
                    <span class="product-result-sku">#${item.objectID}</span>
                  </div>
                  <div class="product-result-title">${item.title || Drupal.t('Unknown Title')}</div>
                  <div class="result-prices">
                    ${
                      item.currentPrice != item.regularPrice
                        ? '<div class="special-price"><span class="visually-hidden"> ' +
                          Drupal.t('Current Price') +
                          ' </span><span class="price-no-text">$' +
                          parseFloat(item.currentPrice).toFixed(2) +
                          '</span></div>'
                        : ''
                    }
                    <div class="current-price">
                      <span class="visually-hidden">${
                        item.currentPrice != item.regularPrice
                          ? ' ' + Drupal.t('Original Price') + ' '
                          : ''
                      }</span><span class="price-no-text">$${
              item.regularPrice ? parseFloat(item.regularPrice).toFixed(2) : ''
            }</span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            </div>
             ${
               item.objectID.startsWith('VG')
                 ? `<div class="choose-options product-bottom"><a aria-label="Choose options for ${
                     item.title
                   }" class="btn btn--secondary" href="${
                     item.url.replace(shopDefaultUrl, shopActualUrl) || '#'
                   }" data-hits-index="${index}">
                      ${Drupal.t('Choose Options')}
                    </a></div>`
                 : item.available.toLowerCase().indexOf('in stock') !== -1
                 ? `<div class="add-to-cart product-bottom"><a aria-label="Add to cart: ${
                     item.title
                   }" class="button" href="${shopActualUrl}/cart.php?action=add&sku=${
                     item.axID
                   }" data-hits-index="${index}">
                      ${Drupal.t('Add To Cart')}
                    </a></div>`
                 : ``
             }
           </div>
          </div>
        `
          )
          .join('')}
      `;

      document
        .querySelectorAll(
          '#algolia_results #' +
            widgetParams.container +
            ' .hits .grid__item a.product--details-link'
        )
        .forEach(item => {
          item.addEventListener('click', () => {
            const hindex = item.dataset.hitsIndex || null;
            if (hindex) {
              sendEvent('click', hits[hindex], 'Details Product');
            }
          });
        });

      document
        .querySelectorAll(
          '#algolia_results #' + widgetParams.container + ' .hits .grid__item div.add-to-cart a'
        )
        .forEach(item => {
          item.addEventListener('click', () => {
            const hindex = item.dataset.hitsIndex || null;
            if (hindex) {
              sendEvent('conversion', hits[hindex], 'Add To Cart Product');
            }
          });
        });

      document
        .querySelectorAll(
          '#algolia_results #' + widgetParams.container + ' .hits .grid__item div.choose-options a'
        )
        .forEach(item => {
          item.addEventListener('click', () => {
            const hindex = item.dataset.hitsIndex || null;
            if (hindex) {
              sendEvent('click', hits[hindex], 'View Options Product');
            }
          });
        });
    },

    /**
     * Custom hits rendering for recipe type results.
     */
    renderRecipeHits: ({ hits, widgetParams, sendEvent }, isFirstRender) => {
      if (isFirstRender) {
        document.querySelector('#algolia_results #' + widgetParams.container + ' .hits').innerHTML =
          '<h4>Searching...</h4>';
        return;
      }

      if (hits.length == 0) {
        document.querySelector('#algolia_results #' + widgetParams.container + ' .hits').innerHTML =
          '<h4>No recipe matched your search term.</h4>';
        return;
      }

      document.querySelector('#algolia_results #' + widgetParams.container + ' .hits').innerHTML = `
        ${hits
          .map(
            (item, index) => `
          <div class="grid__item recipe--grid-item"  style="order: ${index + 1};">
            <a href="${item.url || '#'}" data-hits-index="${index}">
              <div class="article article--simple">
                ${
                  typeof item.category_lvl0 !== 'undefined' &&
                  (item.category_lvl0.toString().toLowerCase().includes('mix it up') ||
                    item.category_lvl0.toString().toLowerCase().includes('mix tips'))
                    ? '<div class="product-flag mix_it_up">Mix Tips</div>'
                    : ''
                }
                <figure class="result--image">
                  <img src="${
                    Array.isArray(item.thumbnail)
                      ? item.thumbnail[0]
                      : item.thumbnail || '/themes/custom/kaf_nextgenweb/images/no-search-image.png'
                  }" alt="" />
                </figure>

                <div class="article__content">
                  <div class="grid-item-title">${item.title || 'Unknown Title'}</div>
                  <div class="result-rating">
                    ${
                      item.rating
                        ? '<div class="rating rating-is-' +
                          Math.round(item.rating * 2) * 5 +
                          '">' +
                          item.rating +
                          '</div>'
                        : ''
                    }
                    <span class="visually-hidden"> out of 5 stars rating</span>
                    <div class="rating-count">${
                      item.review_count > 0 ? item.review_count + ' reviews' : 'Not Yet Reviewed'
                    }</div>
                  </div>
                </div>

              </div>
            </a>
          </div>
        `
          )
          .join('')}
      `;

      if(document.querySelectorAll('.view--recipe-category > #algolia_container').length < 1) {
        // Do not track clicks on recipe category pages.
        document
          .querySelectorAll('#algolia_results #' + widgetParams.container + ' .hits .grid__item a')
          .forEach(item => {
            item.addEventListener('click', () => {
              const hindex = item.dataset.hitsIndex || null;
              if (hindex) {
                sendEvent('click', hits[hindex], 'Details Recipe');
              }
            });
          });
      }
    },

    /**
     * Custom hits rendering for general / blog type results.
     */
    renderDefaultHits: (renderOptions, isFirstRender) => {
      const { hits, widgetParams, sendEvent } = renderOptions;

      if (isFirstRender) {
        document.querySelector('#algolia_results #' + widgetParams.container + ' .hits').innerHTML =
          '<h4>Searching...</h4>';
        return;
      }

      if (hits.length == 0) {
        let indexTitle = 'other';
        if (widgetParams.container.indexOf('blog') !== -1) {
          indexTitle = 'blog';
        }
        else if (widgetParams.container.indexOf('class') !== -1) {
          indexTitle = 'class';
        }
        document.querySelector('#algolia_results #' + widgetParams.container + ' .hits').innerHTML = `<h4>No ${indexTitle} matched your search term.</h4>`;
        return;
      }

      const renderIcon = type => {
        switch (type) {
          case 'ondemand':
            return `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.10663 2.5C0.495452 2.5 0 3.0534 0 3.73605V13.2639C0 13.9466 0.495452 14.5 1.10663 14.5H14.8934C15.5045 14.5 16 13.9466 16 13.2639V3.73605C16 3.0534 15.5045 2.5 14.8934 2.5H1.10663ZM1.4755 3.83906C1.37364 3.83906 1.29107 3.9313 1.29107 4.04506V12.9034C1.29107 13.0172 1.37364 13.1094 1.4755 13.1094H14.4784C14.5803 13.1094 14.6628 13.0172 14.6628 12.9034V4.04506C14.6628 3.9313 14.5803 3.83906 14.4784 3.83906H1.4755Z" fill="#DA1A32"></path><path d="M10.7 8.3268C10.8333 8.40378 10.8333 8.59623 10.7 8.67321L6.8 10.9249C6.66667 11.0019 6.5 10.9056 6.5 10.7517V6.24833C6.5 6.09437 6.66667 5.99815 6.8 6.07513L10.7 8.3268Z" fill="#DA1A32"></path></svg>`;
          case 'inperson':
            return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M14.1918 3.46005C14.1918 5.09484 12.7893 6.4201 11.0594 6.4201C9.32937 6.4201 7.92694 5.09484 7.92694 3.46005C7.92694 1.82526 9.32937 0.5 11.0594 0.5C12.7893 0.5 14.1918 1.82526 14.1918 3.46005Z" fill="#DA1A32"></path><path d="M8.34437 6.56042C7.09389 6.6889 6.11872 7.7397 6.11872 9.01695V15.5H16V9.01695C16 7.72865 15.0079 6.67074 13.7418 6.55729C13.0078 7.12959 12.067 7.47337 11.0411 7.47337C10.0171 7.47337 9.07777 7.13084 8.34437 6.56042Z" fill="#DA1A32"></path><path d="M6.67035 4.24888C6.67035 5.59962 5.51159 6.69461 4.08219 6.69461C2.65279 6.69461 1.49404 5.59962 1.49404 4.24888C1.49404 2.89814 2.65279 1.80314 4.08219 1.80314C5.51159 1.80314 6.67035 2.89814 6.67035 4.24888Z" fill="#DA1A32"></path><path d="M5.30477 7.35268C4.89186 7.79368 4.63927 8.38507 4.63927 9.03511V14.1969H0V9.26938C0 8.10126 0.815648 7.12255 1.91158 6.86554C2.50637 7.30379 3.25447 7.56487 4.0671 7.56487C4.50276 7.56487 4.91988 7.48983 5.30477 7.35268Z" fill="#DA1A32"></path></svg>`;
          case 'virtual':
            return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.75 2.5641C0.75 1.97641 1.19771 1.5 1.75 1.5H14.2083C14.7606 1.5 15.2083 1.97641 15.2083 2.5641V10.7665C15.2083 11.3542 14.7606 11.8306 14.2083 11.8306H1.75C1.19771 11.8306 0.75 11.3542 0.75 10.7665V2.5641ZM1.91667 2.83013C1.91667 2.73219 1.99128 2.65278 2.08333 2.65278H13.8333C13.9254 2.65278 14 2.73219 14 2.83013V10.4562C14 10.5541 13.9254 10.6335 13.8333 10.6335H2.08333C1.99128 10.6335 1.91667 10.5541 1.91667 10.4562V2.83013ZM6.00279 12.8152H0V13.4359C0 14.0236 0.447715 14.5 1 14.5H15C15.5523 14.5 16 14.0236 16 13.4359V12.8152H9.99721C9.96418 13.1989 9.64226 13.5 9.25 13.5H6.75C6.35774 13.5 6.03582 13.1989 6.00279 12.8152Z" fill="#DA1A32"></path></svg>`;
          case 'liveonline':
            return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.75 2.5641C0.75 1.97641 1.19771 1.5 1.75 1.5H14.2083C14.7606 1.5 15.2083 1.97641 15.2083 2.5641V10.7665C15.2083 11.3542 14.7606 11.8306 14.2083 11.8306H1.75C1.19771 11.8306 0.75 11.3542 0.75 10.7665V2.5641ZM1.91667 2.83013C1.91667 2.73219 1.99128 2.65278 2.08333 2.65278H13.8333C13.9254 2.65278 14 2.73219 14 2.83013V10.4562C14 10.5541 13.9254 10.6335 13.8333 10.6335H2.08333C1.99128 10.6335 1.91667 10.5541 1.91667 10.4562V2.83013ZM6.00279 12.8152H0V13.4359C0 14.0236 0.447715 14.5 1 14.5H15C15.5523 14.5 16 14.0236 16 13.4359V12.8152H9.99721C9.96418 13.1989 9.64226 13.5 9.25 13.5H6.75C6.35774 13.5 6.03582 13.1989 6.00279 12.8152Z" fill="#DA1A32"></path></svg>`;
          default:
            return ``;
        }
      };

      document.querySelector('#algolia_results #' + widgetParams.container + ' .hits').innerHTML = `
        ${hits
          .map((item, index) => {
            const thumbnail = item.thumbnail || item.thumbnail_video;
            return `
          <div class="grid__item"  style="order: ${index + 1};">
            <a href="${item.url || '#'}" data-hits-index="${index}">
              <div class="article article--simple">
                <figure class="result--image">
                  <img ${
                    typeof thumbnail === 'undefined' ? 'class="result--image-contain"' : ''
                  } src="${
              Array.isArray(thumbnail)
                ? thumbnail[0]
                : thumbnail || '/themes/custom/kaf_nextgenweb/images/no-search-image.png'
            }" alt="" />
                </figure>
                <div class="article__content">
                  ${
                    typeof item.type === 'undefined'
                      ? ``
                      : `<span class="eyebrow">${item.type}</span>`
                  }
                  <div class="grid-item-title">${item.title || 'Unknown Title'}</div>
                  ${
                    typeof item.field_class_type === 'undefined'
                      ? ``
                      : `<span class="article--class-content"> ${renderIcon(
                          item?.field_class_type.replace('_', '')
                        )} ${
                          typeof item.kaf_parent_class_duration === 'undefined'
                            ? ``
                            : `<p>${item.kaf_parent_class_duration}</p></span>`
                        }`
                  }
                </div>
              </div>
            </a>
          </div>
        `;
          })
          .join('')}
      `;

      document
        .querySelectorAll('#algolia_results #' + widgetParams.container + ' .hits .grid__item a')
        .forEach(item => {
          item.addEventListener('click', () => {
            const hindex = item.dataset.hitsIndex || null;
            if (hindex) {
              sendEvent('click', hits[hindex], 'Details Default');
            }
          });
        });
    },

    /**
     * Custom Ingredients Include / Exclude Filter Widget.
     */
    ingredientsWidget: (container, exclude) => {
      return {
        init(options) {
          const { helper } = options;
          const fid = `filter_ingredients_${!!exclude ? 'excluded' : 'included'}`;
          let filterDiv = document.createElement('div');
          filterDiv.classList.add('filter');
          filterDiv.setAttribute('id', fid);
          const ingredientsWidgetFilterContainer = document.querySelector(
            `#algolia_results #${container} .filters #${Drupal.kafHelper.checkIndex(
              'recipe_index'
            )}_filters_filter-by-ingredient`
          );
          ingredientsWidgetFilterContainer.append(filterDiv);

          const placeholder = exclude ? 'Exclude Ingredients' : 'Include Ingredients';
          const selectList = document.createRange().createContextualFragment(`
            <div class="select js-multiselect ${fid}">
              <input
                    aria-activedescendant="listbox-${fid}"
                    aria-autocomplete="none"
                    aria-controls="listbox-${fid}"
                    aria-expanded="false"
                    aria-haspopup="listbox"
                    aria-label="${placeholder} Filter"
                    aria-labelledby="select-label select-selected"
                    class="select-input"
                    id="select-${fid}"
                    role="combobox"
                    type="text"
                    placeholder="${placeholder}"
                    />
              <div class="select-menu" role="listbox" id="listbox-${fid}"></div>
            </div>
            <span id="select-${fid}-remove" style="display: none">remove</span>
            <ul class="selected-options" id="select-${fid}-selected"></ul>
            `);

          filterDiv.appendChild(selectList);
          const selectListInput = document.getElementById(`select-${fid}`);

          selectListInput.addEventListener('input', event => {
            const query = event.currentTarget.value;

            if (query === '' && this.lastItemsFromMainSearch) {
              this.renderItems(this.lastResultsFromMainSearch);
            } else {
              helper.searchForFacetValues('ingredients_base', query, 100, {}).then(results => {
                const facetValues = results.facetHits.map(({ value, ...item }) => ({
                  ...item,
                  value,
                  name: value,
                }));

                this.renderItems(facetValues);
              });
            }
          });

          // Initialize multiselect list object after all HTML has been rendered.
          const multiselectComponent = Drupal.theme.multiSelect(`.${fid}`, [], helper, exclude);
          multiselectComponent.init();
          this.multiSelect = multiselectComponent;
        },

        render(options) {
          const {
            results,
            state,
            createURL,
            instantSearchInstance,
            isFromSearch = false,
            helper,
          } = options;

          let items = [];

          if (results && results.nbHits) {
            if (!isFromSearch) {
              if (drupalSettings.kaf_search.is_prod) {
                items = results.getFacetValues('ingredients_base') || [];
              }
            } else {
              items = transformItems(
                results.facetHits.map(({ value, ...item }) => ({
                  ...item,
                  value,
                  name: value,
                }))
              );
            }
          }
          this.lastResultsFromMainSearch = results;
          this.lastItemsFromMainSearch = items;
          this.renderItems(items);
        },

        getWidgetState(uiState, widgetStateOptions) {
          const { searchParameters } = widgetStateOptions;
          const widgetKey = exclude ? 'ingredients_exclude' : 'ingredients_include';

          const values = exclude
            ? searchParameters.getExcludeRefinements('ingredients_base')
            : searchParameters.getConjunctiveRefinements('ingredients_base');

          if (!values.length) {
            return uiState;
          }

          return {
            ...uiState,
            [widgetKey]: {
              ...uiState[widgetKey],
              ingredients_base: values,
            },
          };
        },

        getWidgetSearchParameters(searchParameters, { uiState }) {
          const attribute = 'ingredients_base';
          const widgetKey = exclude ? 'ingredients_exclude' : 'ingredients_include';
          const widgetState = uiState[widgetKey] ?? {};
          const values = widgetState[attribute] ?? null;
          const withFacetConfiguration = searchParameters.addFacet(attribute);
          const withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter(
            'maxValuesPerFacet',
            20
          );

          if (!values) {
            const key = exclude ? 'facetsExcludes' : 'facetsRefinements';

            return withMaxValuesPerFacet.setQueryParameters({
              [key]: {
                ...withMaxValuesPerFacet[key],
                [attribute]: [],
              },
            });
          }

          return values.reduce(
            (parameters, value) =>
              exclude
                ? parameters.addExcludeRefinement(attribute, value)
                : parameters.addFacetRefinement(attribute, value),
            withMaxValuesPerFacet
          );
        },

        renderItems(items) {
          this.multiSelect.setOptions(items.map(item => item.name));
        },

        lastItemsFromMainSearch: null,
        lastResultsFromMainSearch: null,
      };
    },
    multiSelect: null,
    container: null,
    searchClient: null,
    mobileSelectTabs: null,
    is: null,
    initialized: false,
    queryInitialized: false,
  };
})(Drupal, drupalSettings, algoliasearch, instantsearch);
